export default __webpack_public_path__ + "static/media/12-14.233fbc25.png";